import { Button, ModalPanel, SingleLineTextInput, Title } from "dash-styled"
import React, { FC, FormEvent, useCallback } from "react"
import { useInput } from "../../../../../../Hooks/useInput"

interface WorkerGroupAddModalProps {
    isSaving: boolean
    onClose: () => void
    onSubmit: (name: string) => void
}

export const WorkerGroupAddModal: FC<WorkerGroupAddModalProps> = ({
    isSaving,
    onClose,
    onSubmit
}) => {
    const nameInput = useInput("", false)
    const handleSubmit = useCallback(
        (e: FormEvent<HTMLFormElement>) => {
            e.preventDefault()

            if (nameInput.isValid) {
                onSubmit(nameInput.value)
            }
        },
        [nameInput.isValid, nameInput.value, onSubmit]
    )

    return (
        <ModalPanel onClose={onClose} className="max-w-2xl w-full">
            <Title variant="heading2" weight="semibold" component="h2">
                Add new worker group
            </Title>
            <form onSubmit={handleSubmit}>
                <SingleLineTextInput
                    label="Name"
                    required={true}
                    autoFocus={true}
                    pattern="^[^\s].*[^\s]$"
                    {...nameInput}
                />
                <Button
                    type="submit"
                    className="w-auto mt-8 px-8"
                    disabled={isSaving || !nameInput.isValid}
                >
                    {isSaving ? "Adding..." : "Add"}
                </Button>
            </form>
        </ModalPanel>
    )
}
